/**
 * Label/value pair rendered inside a Grid cell — a muted caption label over
 * a plain value. Used throughout the status detail panel's field lists
 * (device info, network details) so each row shares one layout.
 *
 * Contains:
 *  - LabeledValue — default export
 */

import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

function LabeledValue({ label, value = null, size = { xs: 12, sm: 6, md: 3 } }) {
  return (
    <Grid size={size}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography>{value}</Typography>
    </Grid>
  );
}

LabeledValue.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
};

export default LabeledValue;
